var map = {
	"./decisions-dark.svg": 39237,
	"./decisions.svg": 88222,
	"./knowledge-dark.svg": 93510,
	"./knowledge.svg": 5814,
	"./quote-dark.svg": 68066,
	"./read-more-dark.svg": 80144,
	"./read-more.svg": 32463,
	"./retention-dark.svg": 40476,
	"./retention.svg": 9736,
	"./save-time-dark.svg": 19285,
	"./save-time.svg": 3142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98142;